import styled from 'styled-components';
import { colors } from '@/styles';

export const NavTabs = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 30px;
  padding-bottom: 0px;
  /* border: 1px solid lime; */
  /* border-bottom: 1px solid ${colors.secondary.lightGray2}; */
`;

export const Tab = styled.div<{ $active?: boolean; disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 0 10px 0;
  border-bottom: ${(props) => (props.$active ? `1px solid ${colors.primary.black}` : 'none')};
  margin-bottom: -1px;
  color: ${(props) => (props.disabled ? colors.semantic.disabled : colors.primary.black)};
`;
